import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 600px;
  max-width: 90%;
  margin: auto;
  padding: 64px;
  background-color: ${({ theme }) => theme.text.primary};
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
    padding: 16px;
  }
`;
